const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class TripleCtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.1,
              spacing: 0,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3,
              spacing: 0,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('triple-cta-carousel')) {
  customElements.define('triple-cta-carousel', TripleCtaCarousel)
}
